import React from "react";
import "../../../../assets/scss/components/generic/navigationTag.scss";
import { Link } from "react-router-dom";
import { IListObj } from "../../../types/genericTypes";

export interface IMarginNavigationTagProps {
	defaultValue?: number | string; // default selected value
	tagList: Array<IListObj>; // list of all tags
}

const MarginNavigationTag: React.FC<IMarginNavigationTagProps> = (props: IMarginNavigationTagProps) => {
	return (
		<ul className="tag_navigation_content">
			{props.tagList.map(tag => (
				<li className={"tag" + (tag.value === props.defaultValue ? " active" : "")} key={tag.value}>
					{tag.href && <Link to={tag.href}>{tag.display}</Link>}
					{!tag.href && tag.display}
				</li>
			))}
		</ul>
	);
};

export default MarginNavigationTag;
